<template>
    <div class="ma-4">
        <ClientNav/>
        <v-row dense>
            <v-col cols="12">
                <v-card>
                    <v-card-title style="background-color: #2b3990">
                        <span class="headline white--text">{{ titleForm }}</span>
                    </v-card-title>
                    <v-card-text>
                        <v-container>
                            <!-- <ect @clicked="selectedCode" /> -->

                            <v-row>
                                <v-col cols="12" sm="12" md="6">
                                    <v-autocomplete
                                        v-model="newBehavior"
                                        label="Behavior"
                                        :items="behaviorList"
                                    ></v-autocomplete>
                                </v-col>
                                <v-col cols="12" sm="12" md="6">
                                    <v-menu
                                        ref="menu"
                                        v-model="menu"
                                        :close-on-content-click="false"
                                        :return-value.sync="date"
                                        transition="scale-transition"
                                        offset-y
                                        min-width="auto"
                                    >
                                        <template v-slot:activator="{ on, attrs }">
                                            <v-text-field
                                                v-model="newStartDate"
                                                label="Start Date"
                                                prepend-icon="mdi-calendar"
                                                readonly
                                                v-bind="attrs"
                                                v-on="on"
                                            ></v-text-field>
                                        </template>
                                        <v-date-picker
                                            v-model="newStartDate"
                                            no-title
                                            scrollable
                                        >
                                            <v-spacer></v-spacer>
                                            <v-btn
                                                text
                                                color="primary"
                                                @click="menu = false"
                                            >
                                                Cancel
                                            </v-btn>
                                            <v-btn
                                                text
                                                color="primary"
                                                @click="$refs.menu.save(date)"
                                            >
                                                OK
                                            </v-btn>
                                        </v-date-picker>
                                    </v-menu>
                                </v-col>
                                <v-col class="d-flex" cols="12" sm="12" md="6">
                                    <v-menu
                                        ref="menu2"
                                        v-model="menu2"
                                        :close-on-content-click="false"
                                        :return-value.sync="date"
                                        transition="scale-transition"
                                        offset-y
                                        min-width="auto"
                                    >
                                        <template v-slot:activator="{ on, attrs }">
                                            <v-text-field
                                                v-model="newEndDate"
                                                label="End Date"
                                                prepend-icon="mdi-calendar"
                                                readonly
                                                v-bind="attrs"
                                                v-on="on"
                                            ></v-text-field>
                                        </template>
                                        <v-date-picker
                                            v-model="newEndDate"
                                            no-title
                                            scrollable
                                            :min="minEndDate"
                                        >
                                            <v-spacer></v-spacer>
                                            <v-btn
                                                text
                                                color="primary"
                                                @click="menu2 = false"
                                            >
                                                Cancel
                                            </v-btn>
                                            <v-btn
                                                text
                                                color="primary"
                                                @click="$refs.menu2.save(date)"
                                            >
                                                OK
                                            </v-btn>
                                        </v-date-picker>
                                    </v-menu>
                                </v-col>
                            </v-row>
                        </v-container>
                    </v-card-text>

                    <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn
                            fab
                            small
                            @click="showPrintModal()"
                            class="mr-8 mb-2 white--text"
                            color="#2b6993"
                            elevation="4"
                            v-if="!createBehavior"
                        >
                            <v-icon>print</v-icon>
                        </v-btn>
                        <v-btn
                            class="white--text"
                            color="#259647"
                            @click="addBehavior()"
                            v-if="createBehavior"
                        >Save
                        </v-btn
                        >
                        <v-btn
                            color="blue darken-1 white--text"
                            @click="updateBehavior()"
                            v-if="!createBehavior"
                        >Update
                        </v-btn
                        >
                        <v-btn color="blue darken-1" text @click="close"
                        >Cancel
                        </v-btn
                        >
                    </v-card-actions>
                </v-card>
            </v-col>
        </v-row>
        <Foot/>
    </div>
</template>

<script>
import axios from "axios";
import ClientNav from "../../../components/ClientNav";
import Foot from "../../../components/Footer";
import moment from "moment";
import {BEHAVIORS} from "src/constants/Behaviors";
import {displaySuccess, displayError} from "@/service/notification-message.service";
import PrintUtil from "../../../../utils/print-util";


const url = require("../../../client_config/config").url;

export default {
    components: {
        ClientNav,
        Foot,
    },
    data: function () {
        return {
            headers: [
                {
                    text: "Behavior",
                    align: "start",
                    sortable: false,
                    value: "Behavior",
                },
                {text: "Start Date", value: "StartDate"},
                {text: "EndDate", value: "EndDate"},
                {text: "Actions", value: "actions", sortable: false},
            ],
            date: new Date(Date.now() - new Date().getTimezoneOffset() * 60000)
                .toISOString()
                .substr(0, 10),
            menu: false,
            menu2: false,
            msg: false,
            search: "",
            text: "",
            behavior: {},
            tempData: [],
            clientID: this.$route.params.clientID,
            behaviorId: this.$route.params.id,
            token: localStorage.getItem('token'),
            titleForm: "New Behavior",
            behaviorList: BEHAVIORS,
            behaviorID: "",
            newStartDate: moment(new Date()).format("YYYY-MM-DD"),
            newBehavior: '',
            newEndDate: moment(new Date()).format("YYYY-MM-DD"),
            item: "",
            editedIndex: -1,
            editedItem: {
                startDate: "",
                behavior: "",
                endDate: "",
            },
            defaultItem: {
                startDate: "",
                behavior: "",
                endDate: "",
            },
            isLoading: true,
            createBehavior: false
        };
    },

    computed: {
        minEndDate() {
            return this.newStartDate ? this.newStartDate : null;
        },
    },

    watch: {},

    created() {
        this.createBehavior = this.$route.query.newBehavior === 'true';
    },

    mounted() {
        if (!this.createBehavior) {
            this.getBehavior();
        }

        window.addEventListener('keydown', async (event) => {
            this.downloadUrl = await this.generateDownloadUrl();
            PrintUtil.handleKeydown(event, this.downloadUrl, this.behaviorId, this.token, 'Behaviors');
        });
    },

    beforeDestroy() {
        window.removeEventListener('keydown', (event) => {
            PrintUtil.handleKeydown(event, this.downloadUrl, this.behaviorId, this.token, 'Behaviors');
        });
    },

    methods: {
        initialize() {
            this.behaviors = [];
        },

        viewBehavior(item) {
            this.titleForm = "Viewing " + item.Behavior;
            this.newStartDate = item.StartDate;
            this.newBehavior = item.Behavior;
            this.newEndDate = item.EndDate;
        },

        close() {
            this.clear();
            this.$router.go(-1)
            this.$nextTick(() => {
                this.editedItem = Object.assign({}, this.defaultItem);
                this.editedIndex = -1;
            });
        },

        async updateBehavior() {
            let req_body = {
                StartDate: this.newStartDate,
                Behavior: this.newBehavior,
                EndDate: this.newEndDate,
            };

            try {
                const response = await axios.put(`${url}/behaviors/${this.behaviorId}`, req_body);
                if (response.status !== 200) {
                    displayError('An error occurred updating the behavior');
                }
                displaySuccess('Behavior updated successfully');
                this.getBehaviors();
            } catch (error) {
                console.log(error)
            } finally {
                this.close();
            }
        },

        getBehaviors() {
            this.isLoading = true;
            axios.get(`${url}/behaviors/client/${this.clientID}`)
                .then((res) => {
                    this.behaviors = res.data.behaviors;
                })
                .finally(() => (this.isLoading = false));
        },

        getBehavior() {
            this.isLoading = true;
            axios.get(`${url}/behaviors/${this.behaviorId}`)
                .then((res) => {
                    this.behavior = res.data.behavior;
                    this.viewBehavior(this.behavior)
                })
                .finally(() => (this.isLoading = false));
        },

        async addBehavior() {
            let req_body = {
                StartDate: this.newStartDate,
                Behavior: this.newBehavior,
                EndDate: this.newEndDate,
                ClientID: this.clientID,
            };

            try {
                const response = await axios.post(`${url}/behaviors`, req_body)
                if (response.status !== 200) {
                    displayError('An error occurred adding the behavior');
                }
                displaySuccess('Behavior added successfully');
                this.getBehaviors();
            } catch (error) {
                displayError('An error occurred adding the behavior');
            } finally {
                this.close()
            }
        },

        async generateDownloadUrl() {
            return `${url}/behaviors/print?id=${this.behaviorId}`;
        },

        async showPrintModal() {
            this.downloadUrl = await this.generateDownloadUrl();
            PrintUtil.showPrintOption(this.downloadUrl, this.behaviorId, this.token,'Behaviors');
        },

        clear() {
            this.newBehavior = "";
            this.newStartDate = moment(new Date()).format("YYYY-MM-DD");
            this.newEndDate = moment(new Date()).format("YYYY-MM-DD");
        },
    },
};
</script>
<style>
@media only screen and (min-width: 768px) {
    .mobile {
        display: none;
    }
}

@media only screen and (max-width: 600px) {
    .desktop {
        display: none;
    }
}
</style>
